<template>
    <v-select
        v-model="formData.value"
        outlined
        :class="[inputCssClass, 'selection-field', 'uku-color-picker']"
        :label="title"
        :items="colors"
        :menu-props="{
            offsetY: true,
            contentClass: 'uku-color-picker-menu',
            auto: true
        }"
        :disabled="!!readonly"
        :error-messages="formData.value_error || errorMessages"
        @change="valueChanged"
    >
        <template v-slot:selection="{}">
            <v-icon v-if="iconType === 'hexagon'" :class="[formData.value + '--text']" :size="28">mdi-hexagon</v-icon>
            <v-avatar
                v-else
                :class="[formData.value]"
                size="28"
                tile
                :style="{ 'borderRadius': '4px' }"
            ></v-avatar>
        </template>
        <template v-slot:item="{ item }">
            <v-icon v-if="iconType === 'hexagon'" :class="[item + '--text']" :size="32" :test-id="`${testIdProp}_${item}`">mdi-hexagon</v-icon>
            <v-avatar
                v-else
                :class="[item]"
                size="32"
                tile
                :style="{ 'borderRadius': '4px' }"
            ></v-avatar>
        </template>
    </v-select>
</template>

<script>
import { computed, ref } from "@vue/composition-api";

export default {
    name: "ColorField",
    props: {
        accountId: {
            type: Number,
            default: 0
        },
        field: {
            type: Object,
            default: null
        },
        value: {
            type: String,
            default: null
        },
        errorMessages: {
            type: String,
            default: null
        },
        inputCssClass: {
            type: String,
            default: ""
        },
        readonly: {
            type: Number,
            default: 0
        },
        testIdProp: {
            type: String,
            default: ""
        },
        title: {
            type: String,
            default: null
        }
    },
    setup(props, ctx) {
        const formData = ref({
            value: props.value,
            value_error: null
        });

        const origValue = computed(() => {
            return props.value;
        });
        const iconType = computed(() => {
            if (props.field == null) return 'rect';
            if (props.field.related_type.startsWith("project.")) return 'hexagon';
            return 'rect';
        })

        const colors = (function () {
            let ret = [];
            for (let i = 1; i <= 48; i++) {
                ret.push("color-{0}".format(i));
            }
            return ret;
        })();

        const valueChanged = function(data) {
            formData.value.value_error = null;
            formData.value.value = data;
            ctx.emit("change", formData.value.value);
        };

        return {
            formData,
            colors,
            iconType,
            valueChanged
        };
    }
};
</script>
